<script>import SVG from "../SVG.svelte";
import Hint from "../Hint.svelte";
import { capitalize } from "../../../utils/strings";
export let props;
</script>

<div class="inline-flex items-center space-x-1 font-semibold ml-2 mb-2">
	{#if props.icon}
		<SVG name={props.icon} />
	{/if}
	{#if props.label}
		<label for={props.id} class={props.required ? 'flex' : ''}>
			{#if props.label.component}
				<svelte:component this={props.label.component} />
			{:else}
				{capitalize(props.label)}
			{/if}
			<span class="text-primary">{props.required ? '*' : ''}</span>
		</label>
	{/if}
	{#if props.hint}
		<div class="flex items-center">
			<Hint tooltip={{ content: props.hint }} />
		</div>
	{/if}
</div>
